import { useAppDispatch } from "../../../redux/useAppDispatch";
import { openTemplateModal, setCurrentRecord } from "../../../redux/SettingModule/OrganizationsPage/OrganizationsPageAction";

function TemplateLink(props: any) {
  const dispatch = useAppDispatch();

  return (
    <div
      className="link"
      onClick={() => {
        dispatch(openTemplateModal());
        dispatch(setCurrentRecord(props.record));
      }}>
      {props.data.length}
    </div>
  );
}

export default TemplateLink;
